import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import {
  TextFields as TextIcon,
  Edit as EditIcon,
  FormatItalic as ItalicIcon,
  CalendarToday as CalendarIcon,
  CheckCircle as CheckIcon,
  Image as ImageIcon,
  FormatListBulleted as DropdownIcon,
  Note as LicenseIcon,
  EmojiObjects as StampIcon,
} from "@mui/icons-material";
import ApprovalIcon from "@mui/icons-material/Approval";

import { styled } from "@mui/system";

// Updated IconWrapper without background
const IconWrapper = styled(Box)(({ color }) => ({
  color: color || "rgba(0, 0, 0, 0.54)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "20px",
  width: "32px",
  height: "32px",
  transition: "color 0.2s ease",
}));

const ForOthers = ({ type, selectedSigner, typeData, disabled, onDisabledClick }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const activeColor = "rgb(33, 179, 232)";
  const forOtherItems = [
    { name: "Text Field", type: "signer_text", icon: <TextIcon /> },
    { name: "Signature Field", type: "signer_initials", icon: <EditIcon /> },
    { name: "Initials Field", type: "signer_initials_text", icon: <ItalicIcon /> },
    { name: "Date Field", type: "signer_date", icon: <CalendarIcon /> },
    { name: "Checkbox Field", type: "signer_checkmark", icon: <CheckIcon /> },
    { name: "Stamp", type: "signer_chooseImgStamp", icon: <ApprovalIcon /> },
    {
      name: "Driving License",
      type: "signer_chooseImgDrivingL",
      icon: <LicenseIcon />,
    },
    {
      name: "Passport Photo",
      type: "signer_chooseImgPassportPhoto",
      icon: <ImageIcon />,
    },
    { name: "Dropdown", type: "signer_dropdown", icon: <DropdownIcon /> },
  ];

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <List
        sx={{
          width: "100%",
          p: 0, // Remove padding from List
          "& .MuiListItem-root": {
            p: 0, // Remove padding from ListItem
          },
        }}
      >
        {forOtherItems.map((item, i) => (
          <ListItem
            key={i}
            disablePadding
            onClick={() => {
              if (disabled) {
                onDisabledClick?.();
                return;
              }
              type(item.type);
            }}
            onMouseEnter={() => !disabled && setHoveredItem(i)}
            onMouseLeave={() => setHoveredItem(null)}
            sx={{
              opacity: disabled ? 0.6 : 1,
              pointerEvents: disabled ? "auto" : "auto",
              cursor: disabled ? "pointer" : "default",
              backgroundColor:
                !disabled && typeData === item.type
                  ? selectedSigner?.color
                    ? (selectedSigner.color.startsWith("#") ? `${selectedSigner.color}20` : "rgba(33, 179, 232, 0.16)")
                    : "rgba(33, 179, 232, 0.16)"
                  : !disabled && hoveredItem === i
                  ? selectedSigner?.color
                    ? (selectedSigner.color.startsWith("#") ? `${selectedSigner.color}12` : "rgba(33, 179, 232, 0.08)")
                    : "rgba(33, 179, 232, 0.08)"
                  : "transparent",
              borderRadius: "4px",
              mb: 0.5,
              transition: "all 0.2s ease",
            }}
          >
            <ListItemButton
              sx={{
                p: "6px 8px",
                minHeight: "32px",
                borderRadius: "4px",
                cursor: disabled ? "pointer" : "default",
                alignItems: "flex-start",
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: "32px",
                  m: 0,
                  mt: "2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IconWrapper
                  color={
                    disabled ? "rgba(0, 0, 0, 0.38)" : (typeData === item.type ? (selectedSigner?.color || activeColor) : "rgba(0, 0, 0, 0.54)")
                  }
                  sx={{
                    width: "24px",
                    height: "24px",
                  }}
                >
                  {React.cloneElement(item.icon, {
                    sx: {
                      fontSize: "18px", // Smaller icon size
                      transition: "all 0.2s ease",
                    },
                  })}
                </IconWrapper>
              </ListItemIcon>
              <ListItemText
                primary={item.name}
                sx={{
                  m: 0,
                  "& .MuiListItemText-primary": {
                    fontSize: "15px",
                    fontWeight: typeData === item.type ? 600 : 400,
                    color: disabled ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0.87)",
                    whiteSpace: "normal",
                    overflow: "visible",
                    lineHeight: 1.3,
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default ForOthers;
